// @flow
import React, { Component } from 'react';
import Circles from 'components/common/Loaders/Circles';
import CheckoutSuccessTemplate from 'components/checkout/CheckoutSuccessTemplate';
import type { State } from 'store';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import qs from 'query-string';
import type { ContextRouter } from 'react-router-dom';
import axios from 'lib/defaultClient';
import { CartActions, OrdersActions, UserActions } from '../../store/actionCreators';

type Props = {
  cart: any,
  order: any,
  logged: any,
  subject: any,
  loading: any,
 } & ContextRouter;

class CheckoutSuccessTemplateContainer extends Component<Props> {
  state = {
    initLoading: true,
  };

  initialize = async () => {
    this.setState({ initLoading: true });
    const query = qs.parse(this.props.location.search);
    if (query.paymentKey) await this.confirm(query);
    await OrdersActions.getOrder(query.orderId);

    if (this.props.logged) {
      this.props.order.items.map(async item => {
        await CartActions.deleteItemCart(item.id);
      });
      await CartActions.getCart();
    } else {
      this.props.order.items.map(async item => {
        await window.CacheBy.LocalCart.deleteItem(item.id);
      });
      await CartActions.getAsNonRegisteredCart({
        items: window.CacheBy.LocalCart.items
      });
    }

    this.setState({ initLoading: false });
  }

  componentDidMount() {
    this.initialize();
  }

  confirm = async (query) => {
    try {
      const response = await axios.post(`/me/orders/confirm`,  {
        orderId: query.orderId,
        amount: query.amount,
        paymentKey: query.paymentKey,
      });

      if (!response.status === 200) {
        // 결제 실패 비즈니스 로직을 구현하세요.
        await this.props.history.push(`/checkout-fail?message=${response.data.message}&code=${response.status}`);
      }
    } catch (e) {
      await this.props.history.push(`/checkout-fail?message=서버에러&code=500`);
    }
  }

  render() {
    const { initLoading } = this.state;
    const { order } = this.props;
    if (initLoading)
      return <Circles color="blue" size="medium" text="Loading..." />;
    return (
      <CheckoutSuccessTemplate order={order} />
    );
  }
}

export default connect(
  ({ cart, user, orders, pender }: State) => ({
    cart,
    logged: !!user.user,
    order: orders.order,
    loading: pender.pending['orders/GET_ORDER'],
  }),
  () => ({}),
)(withRouter(CheckoutSuccessTemplateContainer));



// WEBPACK FOOTER //
// ./src/containers/checkout/CheckoutSuccessTemplateContainer.js